<template>
  <div class="recharge_left capital_first">
    <div>
      <div class="content_title"><h3>{{ $t('logs.fundingDetails') }}</h3></div>

      <div class="content-bg">
        <div class="content_declare">
          <!-- <ul class="ca_ul1">
          <li>
            <a>时间：</a>
          </li>
          <li class="ca_li ca_li_active">
            <a href="#">全部</a>
          </li>
          <li class="ca_li">
            <a href="#">一个星期</a>
          </li>
          <li class="ca_li">
            <a href="#">一个月</a>
          </li>
          <li class="ca_li">
            <a href="#">三个月</a>
          </li>
          <li class="ca_li">
            <a href="#">一年</a>
          </li>
        </ul>-->
          <ul class="ca_ul2">
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'all_log' ? 'active-option' : 'inactive-option'
                "
                @click="getList('all_log')"
                >{{ $t('logs.fullDetails') }}</el-button
              >
            </li>
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'recharge_log' ? 'active-option' : 'inactive-option'
                "
                @click="getList('recharge_log')"
                >{{ $t('logs.recharge') }}
              </el-button>
            </li>
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'withdraw_log' ? 'active-option' : 'inactive-option'
                "
                @click="getList('withdraw_log')"
                >{{ $t('logs.withdraw') }}
              </el-button>
            </li>
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'loan_log' ? 'active-option' : 'inactive-option'
                "
                @click="getList('loan_log')"
                >{{ $t('logs.loadDetails') }}
              </el-button>
            </li>
            <!--<li class="ca_li1">
            <el-button
              :class="nozzle =='loan_log' ? 'active-option':'inactive-option'"
              @click="getList('loan_log')"
            >结算明细</el-button>
          </li>-->
            <!--<li class="ca_li1">
            <el-button
              :class="nozzle =='extract_log' ? 'active-option':'inactive-option'"
              @click="getList('extract_log')"
            >利润提取</el-button>
          </li>-->
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'manage_log' ? 'active-option' : 'inactive-option'
                "
                @click="getList('manage_log')"
                >{{  $t('logs.mgtCosts') }}
              </el-button>
            </li>
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'vouchermanage_log'
                    ? 'active-option'
                    : 'inactive-option'
                "
                @click="getList('vouchermanage_log')"
                >{{ $t('logs.voucher') }}
              </el-button>
            </li>
            <li class="ca_li1">
              <el-button
                :class="
                  nozzle == 'give_back' ? 'active-option' : 'inactive-option'
                "
                @click="getList('give_back')"
                >{{ $t('logs.cashBack') }}
              </el-button>
            </li>
          </ul>
        </div>
        <div class="content_details">
          <el-table
            :data="list"
            height="500"
            stripe
            style="width: 100%"
            :header-cell-style="{ background: 'var(--baseColor)', color: '#FFFFFF', opacity: '0.6' }"
          >
            <el-table-column
              prop="time"
              :label="$t('logs.time')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="name"
              :label="$t('logs.type')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="number"
              :label="$t('logs.amount')"
              width="200"
            ></el-table-column>
            <el-table-column prop="balance" label="余额"></el-table-column>
            <el-table-column
              v-if="nozzle === 'recharge_log' || nozzle === 'withdraw_log'"
              prop="status"
              :label="$t('logs.balance')"
            ></el-table-column>
          </el-table>
          <!-- <el-pagination
          v-if="nozzle==='recharge_log' || nozzle==='withdraw_log'"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-count="page">
        </el-pagination>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";

export default {
  name: "Detailed",
  data() {
    return {
      list: [],
      nozzle: "",
      page: 1
    };
  },
  mounted: function () {
    const defaultTab = this.$route.query.tab || 'all_log';
    this.getList(defaultTab);
  },
  methods: {
    getList(nozzle, type) {
      let that = this;
      if (that.nozzle != nozzle || type == 1) {
        that.nozzle = nozzle;
        if (nozzle === 'give_back') {
          that.$http({
            url: "/app/FlowLog/all_log",
            method: "post",
            data: {
              // nozzle: 'all_log',
              // token: sessionStorage.getItem("token"),
              type: 14
            }
          })
            .then(function (res) {
              if (res.data.status == 200) {
                /*if (res.data.data.length == 0) {
                  that.$message.error("暂无数据");
                } else {
                  that.list = res.data.data;
                }*/
                that.list = res.data.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        } else {
          let baseUrl = ''
          if (nozzle === 'all_log') {
            baseUrl = `/app/FlowLog/all_log`
          } else if (nozzle === 'recharge_log') {
            baseUrl = `/app/Recharge/recharge_log`
          } else if (nozzle === 'withdraw_log') {
            baseUrl = `/app/Withdraw/withdraw_log`
          } else if (nozzle === 'loan_log') {
            baseUrl = `/app/LoanLog/loan_log`
          } else if (nozzle === 'manage_log') {
            baseUrl = `/app/ManageLog/manage_log`
          } else {
            baseUrl = `/app/FirstVoucher/managementLog`
          }
          that.$http({
            url: baseUrl,
            method: "post",
            data: {}
          })
            .then(function (res) {
              if (res.data.status == 200) {
                /*if (res.data.data.length == 0) {
                  that.$message.error("暂无数据");
                } else {
                  that.list = res.data.data;
                }*/
                if (nozzle === 'recharge_log' || nozzle === 'withdraw_log') {
                  let list = res.data.data;
                  if (nozzle === 'recharge_log') {
                    let temp = list;
                    for (let i = 0, len = temp.length; i < len; i++) {
                      switch (temp[i].status) {
                        case 0:
                          temp[i].status = that.$t('detailed.moderated');
                          break;
                        case 1:
                          temp[i].status = that.$t('detailed.rechargeSuccessfull');
                          break;
                        case 2:
                          temp[i].status = that.$t('detailed.rechargeFailed');
                          break;
                      }
                    }
                    that.list = temp;
                    // that.page = res.data.data.page
                  } else {
                    that.list = list;
                  }
                } else {
                  that.list = res.data.data;
                }
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        }

      }
    },
    handleCurrentChange(page) {
      let that = this;
      let nozzle = that.nozzle;
      if (nozzle === 'recharge_log') {
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: nozzle,
            token: sessionStorage.getItem("token"),
            page: page
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              let temp = resData.data.data;
              for (let i = 0, len = temp.length; i < len; i++) {
                switch (temp[i].status) {
                  case 0:
                    temp[i].status = '等待审核';
                    break;
                  case 1:
                    temp[i].status = '充值成功';
                    break;
                  case 2:
                    temp[i].status = '充值失败';
                    break;
                }
              }
              that.page = resData.data.page;
              that.list = temp;
            } else if (res.data.code == 0) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      } else if (nozzle === 'withdraw_log') {
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: nozzle,
            token: sessionStorage.getItem("token"),
            page: page
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.page = resData.data.page;
              that.list = resData.data.data;
            } else if (res.data.code == 0) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
  }
};
</script>
<style scoped>
.active-option {
  border: 2px solid var(--baseColor);
  background: var(--baseColor) !important;
  color: #fff !important;
}
.active-option:active {
  border-color: #ee5c35 !important;
}
.active-option:focus {
  border-color: #ee5c35 !important;
}
.inactive-option {
  border: 2px solid var(--baseColor);
  background-color: #ffffff;
  color: var(--baseColor);
}
.inactive-option:hover {
  background-color: var(--baseColor) !important;
  color: #ffffff !important;
  border: 2px solid var(--baseColor) !important;
}

.perfect_title {
  width: 100%;
  height: 70px;
  text-align: left;
  margin-bottom: 50px;
  border-bottom: 1px solid #2b7ea8;
}

.perfect_title div {
  text-align: center;
  width: 100px;
  height: 69px;
  line-height: 69px;
  color: #2b7ea8;
  font-weight: 600;
  margin-left: 12px;
  border-bottom: 2px solid #2b7ea8;
}

.perfect_content {
  width: 100%;
  margin: 20px auto 0;
  border: 1px solid #ccc;
  padding-bottom: 20px;
}

.content_title {
  text-align: left;
  /* margin-left: 20px; */
  padding: 20px;
  background-color: #ffffff;
  border-radius: 15px;
  margin: 0px 0px 20px 20px;
}

.content_declare {
  height: 100px;
  line-height: 40px;
  color: #8388a5;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  padding-left: 20px;
  /* border-top: 1px solid white; */
}

/*资金明细*/
.content_declare > ul:first-child {
  margin-top: 30px;
  margin-bottom: 10px;
}

.content_declare > ul > li {
  display: inline-block;
}

.content_declare > ul > li:first-child > a {
  padding: 0;
  width: auto;
}

.content_declare > ul > li > a {
  display: inline-block;
  color: #000;
  font-size: 16px;
  line-height: 35px;
  width: 85px;
  text-align: center;
  color: #566b96;
}

.ca_li_active > a {
  background: #566b96 !important;
  color: #fff !important;
}

.content_details {
  /* width: 960px; */
  margin-left: 15px;
  text-align: center;
}

.details_title {
  width: 100%;
  height: 55px;
  line-height: 55px;
  text-align: center;
  background-color: #f2f2f2;
}

.details_title div {
  display: inline-block;
  width: 8%;
  margin: 0;
  padding: 0;
  color: #444;
}

.details_title div:first-child {
  width: 20%;
}

.details_title div:last-child {
  width: 30%;
}

.content_content {
  width: 960px;
  text-align: center;
}

.details_first div {
  width: 8%;
  height: 55px;
  line-height: 55px;
  display: inline-block;
  font-size: 14px;
  color: #999;
}

.details_first div:first-child {
  width: 20%;
}

.details_first div:last-child {
  width: 30%;
}

.M-box2 {
  float: right;
  margin-top: 30px;
}

.content-bg {
  background-color: #ffffff;
  border-radius: 15px;
  padding: 20px 20px 20px 20px;
  margin: 0px 0px 20px 20px;
}
</style>






// WEBPACK FOOTER //
// src/components/detailed.vue